import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Lab, PlusIcon } from '@images';
import { patientRadiologistActions, consultationActions } from '@actions';
import { Breadcrumb, H1, Add, Pagination, StateCard, Modal } from '@utils';
import { Container, RequestMedicalRecordForm } from '@components';
import styled from '@emotion/styled/macro';

const MRIsWrapper = styled.div`
  h1 {
    font-size: 30px;
  }
  a {
    font-family: AvenirNext;
    font-size: 14px;
    font-weight: 500;
    color: #9298ac;
  }
  .ant-breadcrumb-separator {
    margin-right: 5px;
    color: #9298ac;
  }
  .add {
    margin-bottom: 25px;
  }
  .pagination {
    max-width: 780px;
    margin-left: 0;
  }
  .request {
    display: block;
    margin: 15px 0;
    color: #5cb3db;
    img {
      margin-right: 10px;
      width: 25px;
      height: 25px;
      margin-top: 20px;
      position: relative;
      top: -11px;
    }
  }
`;

class MRIs extends Component {
  componentDidMount() {
    const {
      getMRIs,
      match: {
        params: { patientId },
      },
      getSharedMRIs,
    } = this.props;
    const sharedToken = new URLSearchParams(this.props.location.search).get(
      'sharedToken'
    );
    if (patientId && !sharedToken) {
      getSharedMRIs(patientId);
    } else if (patientId && sharedToken) {
      getSharedMRIs(patientId, sharedToken);
    } else {
      getMRIs();
    }
  }
  state = {
    showModal: false,
  };

  handelCloseModal = () => {
    this.setState({ showModal: false });
  };

  handelShowModal = () => {
    this.setState({ showModal: true });
  };

  setPage = page => {
    const {
      getMRIs,
      match: {
        params: { patientId },
      },
      getSharedMRIs,
    } = this.props;
    const sharedToken = new URLSearchParams(this.props.location.search).get(
      'sharedToken'
    );
    if (patientId && !sharedToken) {
      getSharedMRIs(patientId, null, page);
    } else if (patientId && sharedToken) {
      getSharedMRIs(patientId, sharedToken, page);
    } else {
      getMRIs(page);
    }
  };

  render() {
    const {
      mris,
      match: {
        params: { consiltionId, patientId },
      },
      requestScan,
    } = this.props;
    const { showModal } = this.state;
    const userType = localStorage.getItem('userType');
    const sharedToken = new URLSearchParams(this.props.location.search).get(
      'sharedToken'
    );
    const RequestConsultation = new URLSearchParams(
      this.props.location.search
    ).get('RequestConsultation');
    return (
      <Container>
        <MRIsWrapper>
          <Breadcrumb
            links={[{ item: 'Medical Record ', url: '/#MedicalRecord' }]}
          />
          <H1>MRI</H1>
          {userType === 'consultant' && !sharedToken && (
            <Link
              className="request"
              to="#!"
              onClick={() => this.handelShowModal()}
            >
              <img src={PlusIcon} alt="Plus" />
              Request MRI
            </Link>
          )}
          {userType === 'patient' && !sharedToken && (
            <Add
              to={`/mris/new${
                RequestConsultation ? '?RequestConsultation=1' : ''
              }`}
            />
          )}

          {mris &&
            mris.data.map(report => (
              <StateCard
                location={`http://209.97.130.101/u-dicom-viewer?fileUrl=https://api.hk.phantasm.biz/storage/${report.fileLocation}`}
                key={report.createdAt}
                title={report.title}
                time={report.createdAt}
                patientId={patientId}
              />
            ))}
          {mris && mris.meta.total > mris.meta.per_page && (
            <Pagination
              pageSize={mris.meta.per_page}
              total={mris.meta.total}
              setPage={this.setPage}
            />
          )}
          <Modal
            title={'Request MRI'}
            image={Lab}
            showModal={showModal}
            handelCloseModal={this.handelCloseModal}
          >
            <>
              <RequestMedicalRecordForm
                requestScan={requestScan}
                scanType={'radiology-mri'}
                consultationId={Number(consiltionId)}
                handelCloseModal={this.handelCloseModal}
              />
            </>
          </Modal>
        </MRIsWrapper>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  const {
    mri: { mris },
  } = state.radiologist;
  return {
    mris,
  };
};

const mapDispatchToProps = dispatch => ({
  getMRIs: (page = null) => dispatch(patientRadiologistActions.getMRIs(page)),
  getSharedMRIs: (patientId, sharedToken, page = null) =>
    dispatch(
      patientRadiologistActions.getSharedMRIs(patientId, sharedToken, page)
    ),
  requestScan: ({ scanType, id, title, body }) =>
    dispatch(consultationActions.requestScan({ scanType, id, title, body })),
});

MRIs.propTypes = {
  getMRIs: PropTypes.func.isRequired,
  mris: PropTypes.object,
  match: PropTypes.object.isRequired,
  getSharedMRIs: PropTypes.func.isRequired,
  requestScan: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(MRIs);
